import { m } from 'framer-motion';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

import { alpha } from '@mui/material/styles';
import { Box, CircularProgress } from '@mui/material';

import Logo from '../logo';

// ----------------------------------------------------------------------

// Caricamento leggero: logo che pulsa al centro di un anello sottile che gira.
export default function LoadingLogo({ sx, ...other }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <Box
      sx={{
        width: 80,
        height: 80,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
      {...other}
    >
      <CircularProgress
        variant="determinate"
        value={100}
        size={80}
        thickness={1.5}
        sx={{ position: 'absolute', color: (theme) => alpha(theme.palette.primary.main, 0.12) }}
      />
      <CircularProgress
        size={80}
        thickness={1.5}
        disableShrink
        sx={{ position: 'absolute', color: 'primary.main', '& circle': { strokeLinecap: 'round' } }}
      />
      <m.div
        animate={{ scale: [1, 0.9, 1], opacity: [1, 0.6, 1] }}
        transition={{ duration: 1.6, ease: 'easeInOut', repeat: Infinity }}
      >
        <Logo disabledLink sx={{ width: 36, height: 36 }} />
      </m.div>
    </Box>
  );
}

LoadingLogo.propTypes = {
  sx: PropTypes.object,
};
